// extracted by mini-css-extract-plugin
module.exports = {"containerLight":"BorderCountry_containerLight__3fOeA","containerDark":"BorderCountry_containerDark__3yrK5","container":"BorderCountry_container__2f-8f"};